/**
 * Data-driven role registry. Only `developer` is enabled for v1; the rest are
 * declared so the shape is proven and swapping them on is a data change.
 */

export type RoleId = "developer" | "designer" | "pm" | "qa";
export type WorkstationType = "desk" | "drawing_table" | "whiteboard" | "test_lab";

export interface RoleDef {
  id: RoleId;
  label: string;
  icon: string;
  enabled: boolean;
  workstation: WorkstationType;
  /** Work-units contributed per second while working. */
  workRate: number;
  /** Multiplier applied to `WORK_EXHAUSTION_RATE`. */
  exhaustionRate: number;
}

export const ROLES: Record<RoleId, RoleDef> = {
  developer: {
    id: "developer",
    label: "Developer",
    icon: "💻",
    enabled: true,
    workstation: "desk",
    workRate: 1,
    exhaustionRate: 1,
  },
  designer: {
    id: "designer",
    label: "Designer",
    icon: "🎨",
    enabled: false,
    workstation: "drawing_table",
    workRate: 1,
    exhaustionRate: 1,
  },
  pm: {
    id: "pm",
    label: "Product Manager",
    icon: "📋",
    enabled: false,
    workstation: "whiteboard",
    workRate: 1,
    exhaustionRate: 1,
  },
  qa: {
    id: "qa",
    label: "QA",
    icon: "🐞",
    enabled: false,
    workstation: "test_lab",
    workRate: 1,
    exhaustionRate: 1,
  },
};

export const ROLE_IDS = Object.keys(ROLES) as RoleId[];

export function isRoleId(value: unknown): value is RoleId {
  return typeof value === "string" && value in ROLES;
}

export function getRole(id: RoleId): RoleDef {
  return ROLES[id];
}
